import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../helpers/api_helper';

export interface AboutCardTwo {
    id: number;
    pageID: string;
    pageName: string;
    pageContent: string;
    createdBy: string;
    updatedBy: string;
    updated: string;
    createdAt: string;
    pageStatus: number;
}

async function getAboutCardTwo(): Promise<AboutCardTwo | undefined> {
    const apiUrl = '/FrontPage/Page/cf12a32a-5bbf-4c79-9ff1-71b9eafe3caa';

    try {
        const response: AxiosResponse<{ data: AboutCardTwo }> = await axiosInstance.get(apiUrl);

        // Log the entire response data
        console.log('About Us Page Response Data:', response.data);

        // Extract and return the about us page information
        return response.data.data;
    } catch (error: any) {
        console.error('Error fetching About Us page:', error.message);
        // Handle errors here
        throw error;
    }
}

export { getAboutCardTwo };
